import mutations from './chat-visa-mutations';


export default {
  namespaced: true,
  state: {
    showChatVisaFrame: false, // 展示签问对话框
    visa_country_id: 0, // 国家ID，
    sensorData: {}, // 神策埋点
  },
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/chat-visa/chat-visa-store.js